module.exports = __webpack_public_path__ + "media/images/ohap_edit_off-45972882900646b72bbda43c58109068.png";